import api from './client';

export interface PublicResultsSetting {
  enabled: boolean;
}

export interface TestsDisplaySetting {
  card_scale: number;
  order_ids: number[];
}

export const getPublicResultsEnabled = async (): Promise<PublicResultsSetting> => {
  const response = await api.get('/settings/public-results');
  return response.data;
};

export const setPublicResultsEnabled = async (enabled: boolean): Promise<PublicResultsSetting> => {
  const response = await api.put('/settings/public-results', { enabled });
  return response.data;
};

/** Настройки отображения страницы /tests (масштаб и порядок карточек). Публичный GET. */
export const getTestsDisplay = async (): Promise<TestsDisplaySetting> => {
  const response = await api.get('/settings/tests-display');
  return response.data;
};

/** Сохранить настройки отображения /tests (только admin). */
export const saveTestsDisplay = async (
  payload: TestsDisplaySetting,
): Promise<TestsDisplaySetting> => {
  const response = await api.put('/settings/tests-display', payload);
  return response.data;
};